export default {
  ALERT_UPDATED: 'Alert updated successfully',
  ALERT_NOT_UPDATED: 'Alert not updated successfully',
  ALERT_RESOLVED: 'Alert resolved successfully',
  ALERT_NOT_RESOLVED: 'Alert not resolved successfully',
  ASSESSMENT_CREATED: 'Side Effects/Symptoms created successfully',
  ASSESSMENT_NOT_CREATED: 'Side Effects/Symptoms not created successfully',
  ASSESSMENT_DELETED: 'Side Effects/Symptoms deleted successfully',
  ASSESSMENT_NOT_DELETED: 'Side Effects/Symptoms not deleted successfully',
  ASSESSMENT_UPDATED: 'Side Effects/Symptoms updated successfully',
  ASSESSMENT_NOT_UPDATED: 'Side Effects/Symptoms not updated successfully',
  CAREPLAN_CREATED: 'Care plan created successfully',
  CAREPLAN_NOT_CREATED: 'Care plan not created successfully',
  CAREPLAN_UPDATED: 'Care plan updated successfully',
  CAREPLAN_NOT_UPDATED: 'Care plan not updated successfully',
  CAREPLAN_DELETED: 'Care plan deleted successfully',
  CAREPLAN_NOT_DELETED: 'Care plan not deleted successfully',
  FOLLOW_UP_CREATED: 'Follow Up created successfully',
  FOLLOW_UP_NOT_CREATED: 'Follow Up not created successfully',
  FOLLOW_UP_UPDATED: 'Follow Up updated successfully',
  FOLLOW_UP_NOT_UPDATED: 'Follow Up not updated successfully',
  FOLLOW_UP_DELETED: 'Follow Up deleted successfully',
  FOLLOW_UP_NOT_DELETED: 'Follow Up not deleted successfully',
  FOLLOW_UP_RESOLVED: 'Follow Up resolved successfully',
  FOLLOW_UP_NOT_RESOLVED: 'Follow Up not resolved successfully',
  INTERVENTION_CREATED: 'Prescription created successfully',
  INTERVENTION_NOT_CREATED: 'Prescription not created successfully',
  INSTRUCTION_CREATED: 'Instruction created successfully',
  INSTRUCTION_NOT_CREATED: 'Instruction not created successfully',
  INTERVENTION_UPDATED: 'Prescription updated successfully',
  INTERVENTION_NOT_UPDATED: 'Prescription not updated successfully',
  INSTRUCTION_UPDATED: 'Instruction updated successfully',
  INTERVENTION_DELETED: 'Prescription deleted successfully',
  INSTRUCTION_DELETED: 'Instruction deleted successfully',
  INSTRUCTION_NOT_UPDATED: 'Instruction not updated successfully',
  INTERVENTION_NOT_DELETED: 'Prescription not deleted successfully',
  INSTRUCTION_NOT_DELETED: 'Instruction not deleted successfully',
  PATIENT_CREATED: 'Patient created successfully',
  PATIENT_NOT_CREATED: 'Patient not created successfully',
  PATIENT_UPDATED: 'Patient updated successfully',
  PATIENT_DELETED: 'Patient deleted successfully',
  PATIENT_NOT_UPDATED: 'Patient not updated successfully',
  PATIENT_NOT_DELETED: 'Patient not deleted successfully',
  PATIENT_ASSIGNED: 'Patient has assigned a care plan successfully',
  PATIENT_UNASSIGNED: 'Patient has unassigned a care plan successfully',
  PATIENT_NOT_ASSIGNED: 'Patient has not assigned a care plan successfully',
  PATIENT_NOT_UNASSIGNED: 'Patient has not unassigned a care plan successfully',
  PROFILE_UPDATED: 'Profile updated successfully',
  PROFILE_NOT_UPDATED: 'Profile not updated successfully',
  USER_UPDATED: 'User updated successfully',
  USER_DELETED: 'User deleted successfully',
  USER_CREATED: 'User created successfully',
  USER_NOT_UPDATED: 'User not updated successfully',
  USER_NOT_DELETED: 'User not deleted successfully',
  USER_NOT_CREATED: 'User not created successfully',
  DELEGATE_UPDATED: 'CareGiver updated successfully',
  DELEGATE_NOT_UPDATED: 'CareGiver not updated successfully',
  DELEGATE_REMOVED: 'CareGiver removed successfully',
  DELEGATE_NOT_REMOVED: 'CareGiverate not removed successfully',
  DELEGATE_REQUEST_DELETED: 'CareGiver request deleted successfully',
  DELEGATE_REQUEST_NOT_DELETED: 'CareGiver request not deleted successfully'
};

